import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f986d98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-active modal" }
const _hoisted_2 = { class: "modal-card rounded-borders" }
const _hoisted_3 = { class: "modal-card-body is-flex-direction-column" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "title-five" }
const _hoisted_6 = { class: "modal-card-foot justify-to-end" }

import i18n from '@/locales'
import { useComposableForEsc } from '@/components/common/modal/useComposableForEsc'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
  hideActions: Boolean,
  hideCloseButton: Boolean,
  disableBackgroundClick: Boolean,
  disableEscKey: Boolean
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props

useComposableForEsc({
  dismissFunction: () => {
    if (!props.disableEscKey) {
      close()
    }
  }
})

const emit = __emit

const close = () => emit('close')

const handleBackgroundClick = () => {
  if (!props.disableBackgroundClick) {
    close()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-background",
      onClick: handleBackgroundClick
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!__props.hideCloseButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "is-pulled-right delete",
                "aria-label": "close",
                onClick: close
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "title")
          ])
        ]),
        _renderSlot(_ctx.$slots, "body")
      ]),
      _withDirectives(_createElementVNode("footer", _hoisted_6, [
        _renderSlot(_ctx.$slots, "actions", {}, () => [
          _createElementVNode("button", {
            class: "button",
            onClick: close
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(i18n).global.t('close')), 1)
          ])
        ])
      ], 512), [
        [_vShow, !__props.hideActions]
      ])
    ])
  ]))
}
}

})